module.exports = __webpack_public_path__ + "img/1.51312519.svg";